<style src='@/resources/styles/results.css' scoped></style>

<template>

    <div class='keywords-filter filter'>
        <span class='caption'>
          Keywords <span class='help-mark'></span>
      </span>
        <div class='toggle' v-for="(seed, i) in proj.seeds">
            <span class='toggle-label'>{{seed}}</span>
            <button class='toggle-button'
                    :disabled="disableAll"
                    v-bind:class="{on: isSeedActive(seed), disabled: disableAll}" v-on:click="seedChanged(seed)">
                <span class='toggler'></span>
            </button>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    name: 'KeywordFilter',



      data: function() {
        return {
        }
    },

    computed: {
        ...mapGetters(['proj', 'filters', 'isSeedActive', 'isFiltering']),
        disableAll: function() {
            return this.isFiltering;
        }
    },

    methods: {
        ...mapMutations(['chooseSeed', 'setPage']),
        ...mapActions(['filter']),


        seedChanged(seed) {
            this.chooseSeed(seed);
            this.setPage(1);
            const payload = {};
            payload.filters = this.filters;
            this.filter( payload, "" )
                        .then(x => window.scrollTo(0,0));
        }
    },
  }
</script>